<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.6664 11.3545H1.37971H1.33304C1.12064 11.3436 0.913938 11.282 0.730194 11.1749C0.546451 11.0677 0.390997 10.9182 0.276811 10.7388C0.162625 10.5594 0.0930215 10.3552 0.0738101 10.1434C0.0545988 9.93158 0.0863377 9.71824 0.166377 9.52119L4.83304 1.35452C4.94835 1.14612 5.11737 0.97241 5.32254 0.851447C5.52771 0.730485 5.76154 0.666687 5.99971 0.666687C6.23788 0.666687 6.47171 0.730485 6.67688 0.851447C6.88205 0.97241 7.05107 1.14612 7.16638 1.35452L11.833 9.52119C11.9131 9.71824 11.9448 9.93158 11.9256 10.1434C11.9064 10.3552 11.8368 10.5594 11.7226 10.7388C11.6084 10.9182 11.453 11.0677 11.2692 11.1749C11.0855 11.282 10.8788 11.3436 10.6664 11.3545ZM6.66634 4.68783C6.66634 4.31964 6.36786 4.02117 5.99967 4.02117C5.63148 4.02117 5.33301 4.31964 5.33301 4.68783V6.02117C5.33301 6.38936 5.63148 6.68783 5.99967 6.68783C6.36786 6.68783 6.66634 6.38936 6.66634 6.02117V4.68783ZM6.66634 8.68783C6.66634 8.31964 6.36786 8.02117 5.99967 8.02117C5.63148 8.02117 5.33301 8.31964 5.33301 8.68783V8.6945C5.33301 9.06269 5.63148 9.36117 5.99967 9.36117C6.36786 9.36117 6.66634 9.06269 6.66634 8.6945V8.68783Z"
            :fill="iconFill"
        />
    </g>
</template>
<script>
export default {
    name: "WarningTriangle",
    props: {
        iconFill: {
            type: String,
            defaul: "#964040",
        },
    },
};
</script>
